import * as actions from '../Actions/Lists';

export const listsReducer = (state = {}, action) => {
    switch (action.type) {
        case actions.GET_QUESTION_LIST_DATA_REQUESTED:
            return {...state, isLoading: true};
        case actions.GET_QUESTION_LIST_DATA_DONE:
            return {...state, isLoading: false, lists: action.payload};
        case actions.GET_QUESTION_LIST_DATA_FAILED:
            return {...state, isLoading: false, isError: true, error: action.payload};
        default:
            return state;
    }
    };